export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  if (match) return match[2]
  return null
}

export const buildCheckoutUrl = (baseUrl: string): string => {
  if (typeof window === 'undefined') return baseUrl

  try {
    const urlParams = new URLSearchParams(window.location.search)
    const utm_source = urlParams.get('utm_source') || ''
    const utm_medium = urlParams.get('utm_medium') || ''
    const utm_campaign = urlParams.get('utm_campaign') || ''
    const utm_content = urlParams.get('utm_content') || ''
    const utm_term = urlParams.get('utm_term') || ''
    const fbclid = urlParams.get('fbclid') || ''

    const _fbp = getCookie('_fbp') || ''
    const _fbc = getCookie('_fbc') || ''

    const checkoutUrl = new URL(baseUrl)

    // Add individual UTMs
    if (utm_source) checkoutUrl.searchParams.set('utm_source', utm_source)
    if (utm_medium) checkoutUrl.searchParams.set('utm_medium', utm_medium)
    if (utm_campaign) checkoutUrl.searchParams.set('utm_campaign', utm_campaign)
    if (utm_content) checkoutUrl.searchParams.set('utm_content', utm_content)
    if (utm_term) checkoutUrl.searchParams.set('utm_term', utm_term)
    if (fbclid) checkoutUrl.searchParams.set('fbclid', fbclid)

    // Combined attribution for sck and src
    const combinedAttribution = [
      utm_source,
      utm_medium,
      utm_campaign,
      utm_content,
      utm_term,
    ]
      .filter(Boolean)
      .join('|')
    if (combinedAttribution) {
      checkoutUrl.searchParams.set('sck', combinedAttribution)
      checkoutUrl.searchParams.set('src', combinedAttribution)
    }

    // CAPI support
    if (_fbp) checkoutUrl.searchParams.set('_fbp', _fbp)
    if (_fbc) checkoutUrl.searchParams.set('_fbc', _fbc)

    return checkoutUrl.toString()
  } catch (error) {
    console.error('Error building checkout URL:', error)
    return baseUrl // Fallback to clean URL
  }
}

export const handleCheckoutClick = (e: any, baseUrl: string) => {
  if (e && e.preventDefault) {
    e.preventDefault()
  }

  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 6.37,
        currency: 'USD',
        content_name: 'Anger Circuit Breaker',
      })
    }
  } catch (error) {
    console.error('Error tracking InitiateCheckout:', error)
  }

  const finalUrl = buildCheckoutUrl(baseUrl)

  // Small timeout to allow pixel to fire before redirecting
  setTimeout(() => {
    window.location.href = finalUrl
  }, 300)
}
